import { render, staticRenderFns } from "./PontosColeta.vue?vue&type=template&id=50637c9d&scoped=true&"
import script from "./PontosColeta.vue?vue&type=script&lang=ts&"
export * from "./PontosColeta.vue?vue&type=script&lang=ts&"
import style0 from "./PontosColeta.vue?vue&type=style&index=0&id=50637c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50637c9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VFlex,VIcon})
